import React from "react"
import { Check } from "lucide-react"

type OnboardingStepsProps = {
  currentStep: 1 | 2 | 3
  className?: string
  labels?: [string, string, string]
}

const defaultLabels: [string, string, string] = [
  "Select Measures",
  "Choose Scenario",
  "Deploy Simulation",
]

const OnboardingSteps: React.FC<OnboardingStepsProps> = ({
  currentStep,
  className,
  labels = defaultLabels,
}) => {
  return (
    <div className={"w-full max-w-6xl mx-auto mb-8 " + (className || "")}>
      <div className="flex items-center justify-center gap-4">
        {[1, 2, 3].map((step, idx) => (
          <React.Fragment key={step}>
            <div
              className={`w-12 h-12 rounded-full flex items-center justify-center text-base font-medium ${
                currentStep >= step
                  ? "text-white"
                  : "bg-gray-300 text-gray-600"
              }`}
              style={currentStep >= step ? { backgroundColor: '#4D86FF' } : undefined}>
              {currentStep > step ? <Check className="w-5 h-5" /> : step}
            </div>
            {idx < 2 && (
              <div
                className={`w-24 h-1.5 ${
                  currentStep > step ? "" : "bg-gray-300"
                }`}
                style={currentStep > step ? { backgroundColor: '#4D86FF' } : undefined}
              />
            )}
          </React.Fragment>
        ))}
      </div>
      <div className="flex items-center justify-center gap-4 mt-2 text-sm text-gray-600">
        <div className="w-12 text-center">
          <span>{labels[0]}</span>
        </div>
        <div className="w-24"></div>
        <div className="w-12 text-center">
          <span>{labels[1]}</span>
        </div>
        <div className="w-24"></div>
        <div className="w-12 text-center">
          <span>{labels[2]}</span>
        </div>
      </div>
    </div>
  )
}

export default OnboardingSteps
